export default __webpack_public_path__ + "static/gdst-4240078067d4efaa71ae833118ccf88c.svg";